import script from "./chart_score.vue?vue&type=script&setup=true&lang=js"
export * from "./chart_score.vue?vue&type=script&setup=true&lang=js"

import "./chart_score.vue?vue&type=style&index=0&id=6ad65ed2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ad65ed2"]])

export default __exports__